export const mediaQueryValues = {
  XS: '359px',
  S: '479px',
  M: '559px',
  L: '639px',
};

export const mediaQueries = {
  XS: `@media (max-width: ${mediaQueryValues.XS})`,
  S: `@media (max-width: ${mediaQueryValues.S})`,
  M: `@media (max-width: ${mediaQueryValues.M})`,
  L: `@media (max-width: ${mediaQueryValues.L})`,
};

export const verticalMediaQueries = {
  XS: '@media (max-height: 245px)',
  S: '@media (max-height: 265px)',
  M: '@media (min-height: 376px)',
};
